var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case"},[_c('div',{staticClass:"title"},[_vm._v("Stack it up")]),_c('base-grid',{staticStyle:{"padding":"5px"},attrs:{"items":_vm.completedCourses,"imageUrls":_vm.imageUrls,"showTitle":false},on:{"grid:badge:click":function($event){return _vm.$router.push({
        name: 'coursesMentor',
        params: { id: $event.id }
      })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }